<template>
    <div>
        <!-- account_block -->
        <div class="row account_block mt_sm">
            <div class="col-12">
                <div class="info_title account_block_title">
                    <b>Список плательщиков</b>: физических, юридических лиц или
                    индивидуальных предпринимателей, на чье имя выставляется
                    счет и выписываются сопутствующие заказам документы.
                </div>
                <div class="info_body">
                    <div class="form-inline ap_options">
                        <button
                            type="button"
                            class="btn btn_lg btn_common"
                            data-toggle="modal"
                            data-target="#modalPayer"
                        >
                            Показать плательщиков
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- //account_block -->

        <!-- Modal -->
        <order-form-payer-modal v-bind:checkable="false"></order-form-payer-modal>
        
    </div>
</template>

<script>
export default {
    data: function () {
        return {};
    },
    methods: {},
    computed: {},
    mounted() {
        console.log("ProfilePayer");
        this.$store.dispatch("payer/getPayers");
    },
};
</script>
